import { Stack, Typography, Button } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useResponsive } from 'src/hooks/use-responsive';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

export default function LinkExpiredView() {
  // hooks
  const router = useRouter();
  const mdUp = useResponsive('up', 'md');

  return (
    <Stack
      height="100vh"
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Stack alignItems="center" justifyContent="center" px="16px">
        <Iconify
          icon="tabler:alert-triangle-filled"
          width={mdUp ? 160 : 100}
          sx={{
            mb: { xs: '20px', md: '32px' },
          }}
        />
        <Typography
          textAlign="center"
          variant="h3"
          mb={{ xs: '12px', md: '16px' }}
        >
          Invite link is expired
        </Typography>
        <Typography
          variant="input"
          textAlign="center"
          color="content.primaryBlack3"
          mb={{ xs: '18px', md: '24px' }}
        >
          Your invite link is expired recently. Please contact the HR for any
          queries related to invite link.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={() => router.push(paths.auth.jwt.login)}
        >
          Sign In
        </Button>
      </Stack>
    </Stack>
  );
}
